export const handleChangeDataModalProductRating = (name, value) => ({
    type: 'CHANGE_DATA_MODAL_PRODUCT_RATING', name, value
});